import { ensureObject, ensureString } from "../../validate";
import { fetchJson } from "./http";
import {
  COURSES_BASE_URL,
  CoursesApiError,
  type ContentParams,
  type CourseListResponse,
} from "./types";

const FN = "GZIntegracoes.v1.cursos.content";

/**
 * Obtém o conteúdo completo das aulas (com `url-video`), mas apenas das aulas já
 * liberadas. Protegido pelo JWT (`key`) emitido no `signin`/`signup` — a turma e
 * o curso são derivados do próprio token, então não são enviados aqui.
 *
 * HTTP 401 (token inválido/expirado) vira `CoursesApiError` com `status: 401` —
 * o caller deve, nesse caso, refazer o `signin`.
 */
export async function content(params: ContentParams): Promise<CourseListResponse> {
  ensureObject(params, `${FN}(params)`);
  ensureString(params.key, `${FN} → params.key`);

  const query = new URLSearchParams({ key: params.key });

  const { status, ok, body } = await fetchJson(
    `${COURSES_BASE_URL}/content?${query.toString()}`,
  );

  if (!ok) {
    throw new CoursesApiError(
      `${FN}: resposta inesperada da API (status ${status}).`,
      status,
      body,
    );
  }

  return body as CourseListResponse;
}
